<ax-date-picker *ngIf="visible" label="" [(value)]="date" (valueChange)="dateChanged()" [type]="calendarType" [readonly]="readonly" [displayFormat]="displayFormat"></ax-date-picker>
